import { NgModule } from '@angular/core';
import { CustomFormModule } from '@shared/custom-form/custom-form.module';
import { SharedModule } from '@shared/shared.module';
import { IconsModule } from '@shared/icons/icons.module';
import { AgreementListComponent } from './pages/agreement-list/agreement-list.component';
import { AgreementRoutingModule } from './agreement-routing.module';
import { AgreementComponent } from './pages/agreement/agreement.component';
import { AgreementDetailsComponent } from './feature/agreement-info/components/agreement-details/agreement-details.component';
import { PdfViewerComponent } from './feature/components/pdf-viewer/pdf-viewer.component';
import { GeneralAttributesComponent } from './feature/components/general-attributes/general-attributes.component';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { CreateNewAgreementComponent } from './pages/create-new-agreement/create-new-agreement.component';
import { NewAgreementComponent } from './feature/create-new-agreement/components/new-agreement/new-agreement.component';
import { GeneralInfoComponent } from './feature/create-new-agreement/components/general-info/general-info.component';
import { AgreementReminderComponent } from './feature/components/reminder/reminder.component';
import { AgreementActivityComponent } from './feature/components/activity/activity.component';
import { AgreementPaymentComponent } from './feature/components/payment/payment.component';
import { AgreementPartsComponent } from './feature/components/parts/agreement-parts.component';
import { AgreementPeriodsComponent } from './feature/components/periods/agreement-periods.component';
import { NewAgreementPeriodsAndRenewalsComponent } from './feature/create-new-agreement/components/new-agreement-periods-renewals/new-agreement-periods-renewals.component';
import { AgreementFilterComponent } from './components/filter/filter.component';
import { AgreementNotesRemindersComponent } from './feature/components/notes-reminders/notes-reminders.component';
import { AgreementAttachmentComponent } from './feature/components/attachments/agreement-attachment.component';
import { AgreementPeriodsAndRenewalsComponent } from './feature/agreement-info/components/agreement-periods-renewals/agreement-periods-renewals.component';
import { NewAgreementNotesAndActivitiesComponent } from './feature/create-new-agreement/components/new-agreement-notes-activities/new-agreement-notes-activities.component';
import { CreateAndUpdateCounterpartComponent } from './feature/components/counterpart/create-and-update-counterpart.component';
import { ChangeResponsbileModalComponent } from './components/change-responsible-modal/change-responsible-modal.component';
import { ValidationFailuresModalComponent } from './components/validation-failures-modal/validation-failures-modal.component';
import { SendAgreementEmailModalComponent } from './components/send-agreement-email-modal/send-agreement-email-modal.component';
import { RiskAnalysisComponent } from './components/risk-analysis/risk-analysis.component';
import { ListTypeSelectComponent } from './feature/components/listtype-select/listtype-select.component';
import { AgreementSummaryInfoComponent } from './feature/agreement-info/components/agreement-summary-info/agreement-summary-info.component';
import { AgreementSummaryComponent } from './feature/components/summary/agreement-summary.component';
import { AgreementRentalComponent } from './feature/components/rental/rental.component';
import { AgreementRealEstateComponent } from './feature/components/real-estate/real-estate.component';
import { AgreementInventoryComponent } from './feature/components/inventory/inventory.component';
import { InventoryListComponent } from './pages/inventory-list/inventory-list.component';
import { HighlightFieldDirective } from '@shared/directives/highlight-field';
import { NewAgreementRiskAnalysisComponent } from './feature/create-new-agreement/components/new-agreement-risk-analysis/new-agreement-risk-analysis.component';
import { AgreementRiskAnalysisComponent } from './feature/agreement-info/components/agreement-risk-analysis/agreement-risk-analysis.component';
import { AgreementTimelineComponent } from './feature/components/agreement-timeline/agreement-timeline.component';
import { PdfReferenceIconComponent } from './feature/components/pdf-reference-icon/pdf-reference-icon.component';
import { CalendarModalComponent } from './feature/components/calendar-modal/calendar-modal.component';
import { pdfDefaultOptions } from 'ngx-extended-pdf-viewer';

// Configure PDF.js worker for version 21.3.3
pdfDefaultOptions.assetsFolder = 'assets';
// Use ES5 worker for Safari compatibility (no Promise.withResolvers in Web Workers)
pdfDefaultOptions.workerSrc = () => '/assets/pdf.worker-4.6.688-es5.mjs';

@NgModule({
    declarations: [
        AgreementListComponent,
        AgreementComponent,
        CreateNewAgreementComponent,
        NewAgreementComponent,
        GeneralInfoComponent,
        AgreementDetailsComponent,
        GeneralAttributesComponent,
        PdfViewerComponent,
        AgreementPeriodsAndRenewalsComponent,
        AgreementReminderComponent,
        AgreementActivityComponent,
        AgreementPaymentComponent,
        AgreementPartsComponent,
        AgreementPeriodsComponent,
        AgreementTimelineComponent,
        NewAgreementPeriodsAndRenewalsComponent,
        NewAgreementNotesAndActivitiesComponent,
        NewAgreementRiskAnalysisComponent,
        AgreementFilterComponent,
        AgreementNotesRemindersComponent,
        AgreementAttachmentComponent,
        AgreementRiskAnalysisComponent,
        CreateAndUpdateCounterpartComponent,
        ChangeResponsbileModalComponent,
        ValidationFailuresModalComponent,
        SendAgreementEmailModalComponent,
        RiskAnalysisComponent,
        ListTypeSelectComponent,
        AgreementSummaryInfoComponent,
        AgreementSummaryComponent,
        AgreementRentalComponent,
        AgreementRealEstateComponent,
        AgreementInventoryComponent,
        InventoryListComponent,
        PdfReferenceIconComponent,
        CalendarModalComponent
    ],
    imports: [
        SharedModule,
        IconsModule,
        NgxExtendedPdfViewerModule,
        CustomFormModule,
        AgreementRoutingModule,
        HighlightFieldDirective
    ],
    exports: [AgreementFilterComponent]
})
export class AgreementModule {}
